import { useMemo, useState } from 'react'

const getMaxSize = (sizes) => {
  const size = { width: 0, height: 0 }

  Object.keys(sizes).forEach((key) => {
    size.width = Math.max(sizes[key].width, size.width)
    size.height = Math.max(sizes[key].height, size.height)
  })

  return size
}

export const MaxSizeOfItems = ({ children }) => {
  const [sizes, setSizes] = useState({})

  const size = useMemo(() => {
    return getMaxSize(sizes)
  }, [sizes])

  return children(size, setSizes)
}
